import formatISODate from './formatISODate'
import parseUSDayMonthYearDate from './parseUSDayMonthYearDate'

const formatISODateString = (dateString) =>
  formatISODate(parseUSDayMonthYearDate(dateString))

export default formatISODateString
